import {t} from 'i18next';
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import {ReactComponent as CloseIcon} from '../../../../assests/svg/close_icon.svg';

interface Props {
  isOpen: boolean;
  onClose: () => void;
  disablePortal?: boolean; // Use it for jest test case only
}

const stringPath = 'eca.searchTermReport.resultSetting.infoModal.';

const ReportConfigurationInfoDialog: React.FC<Props> = ({
  isOpen,
  onClose,
  disablePortal,
}) => {
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  return (
    <Dialog
      fullScreen={fullScreen}
      open={isOpen}
      onClose={onClose}
      maxWidth={false}
      disablePortal={disablePortal}
      PaperProps={{className: 'str-report-configuration-info-dialog'}}
      data-testid="report-configuration-info-dialog"
    >
      <DialogContent className="modal-content">
        <>
          <div className="report-dialog-title-row">
            <Typography
              className="typo-text headline3_size title-label"
              component="h3"
            >
              {t(stringPath + 'title')}
            </Typography>
            <IconButton onClick={onClose} data-testid="close-button">
              <CloseIcon />
            </IconButton>
          </div>
          <Typography
            component="h4"
            className="typo-text subhead3_size include-hit-title-label"
          >
            {t(stringPath + 'includeHits')}
          </Typography>
          <Typography
            component="h6"
            className="typo-text body2_size content-label"
          >
            {t(stringPath + 'ifUniqueHitEnable')}
          </Typography>
          <ul>
            <li>
              <Typography
                component="p"
                className="typo-text body2_size content-label"
              >
                {t(stringPath + 'uniqueHitPointOne')}
              </Typography>
            </li>
            <li>
              <Typography
                component="p"
                className="typo-text body2_size content-label"
              >
                {t(stringPath + 'uniqueHitPointTwo')}
              </Typography>
            </li>
          </ul>
          <br />
          <Typography
            component="h4"
            className="typo-text subhead3_size include-hit-title-label"
          >
            {t(stringPath + 'storehitQuery')}
          </Typography>
          <Typography
            component="p"
            className="typo-text body2_size content-label"
          >
            {t(stringPath + 'storeHitQueryDec')}
          </Typography>
          <br />
          <Typography
            component="h4"
            className="typo-text subhead3_size include-hit-title-label"
          >
            {t(stringPath + 'includeRelationalGroup')}
          </Typography>
          <Typography
            component="p"
            className="typo-text body2_size content-label"
          >
            {t(stringPath + 'includeRelationalGroupDec')}
          </Typography>
        </>
      </DialogContent>
    </Dialog>
  );
};

export default ReportConfigurationInfoDialog;
